import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { JobsService } from "src/app/services/jobs.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Notification, Subscription } from "rxjs";
import { PaymentDialogComponent } from "../payment-dialog/payment-dialog.component";
import { MatDialog, MatSnackBar } from "@angular/material";
import { PostAJobComponent } from "../post-ajob/post-ajob.component";
import { HttpErrorResponse } from "@angular/common/http";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ReplyDialogComponent } from "../reply-dialog/reply-dialog.component";
import { CancelComponent } from "../cancel/cancel.component";
import { AttachmentSwiperComponent } from "../attachment-swiper/attachment-swiper.component";
import { LoginService } from "src/app/services/login.service";
import { MakeAnOfferComponent } from "../make-an-offer/make-an-offer.component";
import { WithdrawComponent } from "../withdraw/withdraw.component";
import { sha256, sha224 } from "js-sha256";
import { PaymentStatusComponent } from "../payment-dialog/payment-status/payment-status.component";
import { combineLatest } from "rxjs";
import { setDate } from "date-fns";
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: "app-my-task-details",
  templateUrl: "./my-task-details.component.html",
  styleUrls: ["./my-task-details.component.css"],
})
export class MyTaskDetailsComponent implements OnInit {
  id: any;
  showOptions: boolean = false;
  amount: number = 0;
  routeSub: Subscription;
  showDetails: boolean = false;
  selectedOffersLength: number = 0;
  totalSubscribe: Subscription;
  rawData: any = {};
  sampleData: any = {};
  offers: any = [];
  date: any;
  commentForm: FormGroup;
  isMakeOffersCounteReached: boolean = false;
  user: any;
  cuttingAmount: number = 0;
  receivedAmount: any = 0;
  myOfferInfo: any = {};
  couponAmount: string = "";
  loggedIn: boolean = false;
  amIAppliedThisTask: boolean = false;
  amIHired: boolean = false;
  comments: any;
  baseUrl: string = "https://india-live-api.talentasker.com";
  image: string;
  selected: string = "More Options";
  postStatus: any = [];
  shareTaskTitle: string = "";
  shareUrl: string = "";
  isOfferedJob: boolean = false;
  isOfferedExpired: boolean = false;
  isTaskOpen: boolean = false;
  faceBookUrl: string = "";
  twitterUrl: string = "";
  linkedInUrl: string = "";
  selectedLanguage: string;
  bookingID: string = "";
  public coupon: any;
  public OrderNumber: any;
  public PaymentID: any;
  public orderDesc = "Purchasing";
  public merchantCallBackURL = "";
  public custName = "John Doe";
  public custEmail = "Jason@gmail.com";
  public custPhone = "60126902328";
  public PageTimeout = 500;
  public custIP: any;
  public currencyCode = "INR";
  public custOCP = "OCP";
  public PaymentDesc = "testing";
  public TransactionType = "SALE";
  public PymtMethod = "ANY";
  public merchantName = "Startasker";
  public merchantTermsURL = "https://www.talentasker.com/#/term";
  public pass = "H71BRDU8";
  paymentObj: any;
  isWordThere: boolean = false;
  descriptionlang: string = "English";
  showRemaining: boolean = false;
  restrictedKeys: Array<string> = [
    "emailid",
    "email",
    "contact me",
    "mail",
    "mailid",
    "whatsapp",
    "gmailid",
    "gmail",
    "my no",
    "contact no",
    "contact number",
    "site",
    "website",
    "link",
    "address",
    "my location",
    "number",
    "id",
    "phone",
    "phone number",
    "fb",
    "facebook",
    "fb id",
    "+91",
    "60",
    ,
    "contact details",
    "phone details",
    "weblink",
    "web site",
    "Instagram",
  ];
  websiteKeys: Array<string> = [
    "https",
    "http",
    "www.",
    ".in",
    ".org",
    ".edu",
    ".mil",
    ".net",
    ".io",
    ".gov",
    ".tech",
    "@gmail.com",
    ".com",
  ];
  @ViewChild("txtArea", { static: false }) someInput: ElementRef;
  constructor(
    private jobService: JobsService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private translateService: TranslateService,
    private languageService: LanguageService
  ) {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.selectedLanguage = language;
    });
  }

  ngOnInit() {
    this.getIP();
    this.loggedIn = true;
    this.routeSub = this.activatedRoute.params.subscribe((params) => {
      this.id = params["id"];
      this.getTaskDetails();
    });
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.paymentObj = { ...params };
    });
    this.user = JSON.parse(localStorage.getItem("user"));
    this.image = this.baseUrl + this.user.profilePic;
    this.commentForm = this.fb.group({
      postID: [""],
      author_url: [""],
      author: [""],
      author_comment: [""],
      author_email: [""],
      author_ip: [""],
      timeStamp: [""],
      gmt_timeStamp: [""],
    });
    this.switchLanguage(this.selectedLanguage);
  }

  switchLanguage(languageCode: string): void {
    this.translateService.use(languageCode);
  }

  getIP() {
    this.loginService.getIPAddress().subscribe((res: any) => {
      this.custIP = res.ip;
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
      panelClass: "red-snackbar",
    });
  }
  focusTextArea() {
    this.someInput.nativeElement.focus();
  }
  getTaskDetails() {
    let obj = {
      userID: this.id,
    };
    this.loginService.showLoader.next(true);
    this.showOptions = false;
    let token = localStorage.getItem('token')
    this.totalSubscribe = this.jobService.getMyTasks(obj, token).subscribe(
      (posRes) => {
        this.loginService.showLoader.next(false);
        if (posRes.response == 3) {
          this.rawData = posRes.jobsData[0];
          this.isOfferedJob =
            this.rawData.userID == this.user.userID ? false : true;
          this.isTaskOpen = this.rawData.post_Status == "Open" ? true : false;
          this.sampleData = posRes.jobsData[0];
          this.orderDesc = this.rawData.postTitle;
          let paymentStatusObj = JSON.parse(
            localStorage.getItem("paymentStatus")
          );
          if (
            this.rawData &&
            this.rawData.userInfo &&
            this.rawData.userInfo.userID
          ) {
            let num = this.rawData.userInfo.userID
              .replace(/[^0-9 ]/g, "")
              .replace(/ /g, "");
            if (num.substring(0, 2) != "60") {
              num = "+91" + num;
            }
            this.rawData.userInfo.phoneNumber = num;
          }
          if (paymentStatusObj && paymentStatusObj.merchantTransactionId) {
            this.paymentStatus();
          }
          this.loginService.showLoader.next(false);
          this.shareUrl =
            "https://www.Talentasker.com/#/browsejobs/job/" +
            this.rawData.postID;
          this.shareTaskTitle = this.rawData.postTitle;
          this.selectedOffersLength = 0;
          this.offers = this.rawData.offers;
          if (this.isOfferedJob) {
            let index = -1;
            index = this.offers.findIndex((val) => {
              return val.offeredUserID == this.user.userID;
            });
            if (index != -1) {
              this.myOfferInfo = this.offers[index];
              this.amIAppliedThisTask = true;
              this.amIHired = this.myOfferInfo.isTaskerHired;
              this.cuttingAmount = (20 / 100) * this.myOfferInfo.budget;
              this.receivedAmount =
                this.myOfferInfo.budget - this.cuttingAmount;
            } else {
              this.amIAppliedThisTask = false;
              this.myOfferInfo = {};
              this.cuttingAmount = 0;
              this.receivedAmount = 0;
            }
          }
          if (this.rawData.budget.budgetType.Total == false) {
            let num: number = parseInt(this.rawData.budget.Hours);
            this.rawData.budget.budget = num * this.rawData.budget.pricePerHour;
          }
          this.offers.forEach((val, index) => {
            val.isSelected = false;
            if (this.offers[index] && this.offers[index].offeredUserID) {
              let num = this.offers[index].offeredUserID
                .replace(/[^0-9 ]/g, "")
                .replace(/ /g, "");
              if (num.substring(0, 2) != "60") {
                num = "+91" + num;
              }
              this.offers[index].phoneNumber = num;
            }
            if (val.isTaskerHired && !val.isTaskerWithDraw) {
              this.selectedOffersLength += 1;
            }
            val.authorMessages.forEach((x, i) => {
              this.offers[index].authorMessages[i].timestamp = new Date(
                x.timestamp * 1
              );
            });
          });
          if (this.rawData.post_Status == "Expired") {
            this.postStatus = ["Copy"];
          } else if (this.rawData.post_Status == "Cancel") {
            this.postStatus = ["Copy"];
          } else if (this.rawData.post_Status == "Open") {
            this.postStatus = ["Edit", "Copy"];
          } else if (this.rawData.post_Status == "Assigned") {
            this.postStatus = ["Copy"];
          } else {
            this.postStatus = ["Edit"];
          }
          if (this.selectedOffersLength == 0) {
            this.postStatus.push("Cancel Task");
          }
          if (this.rawData.comments.length >= 1) {
            this.comments = this.rawData.comments;
            this.comments.forEach((val, index) => {
              this.comments[index].comment_date = new Date(
                val.comment_date * 1
              );
            });
          }
          this.date = new Date(posRes.jobsData[0].postModifyDate * 1);
        }
      },
      (err: HttpErrorResponse) => {
        this.loginService.showLoader.next(false);
        const txtmsg = err.error.trim();
        const txtmsg2 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg2, '');
      }
    );
  }
  openMakeOffer() {
    if (this.rawData.post_Status == "Open") {
      let data = {};
      if (this.amIAppliedThisTask) {
        data = {
          totalData: this.rawData,
          mydata: this.myOfferInfo,
        };
      } else {
        data = {
          totalData: this.rawData,
        };
      }
      let dialogRef = this.dialog.open(MakeAnOfferComponent, {
        panelClass: "col-md-4",
        hasBackdrop: true,
        disableClose: true,
        data: data,
      });
      this.showOptions = false;
      dialogRef.afterClosed().subscribe((res) => {
        if (res != undefined) {
          if (res.response == 3) {
            const txtmsg = res.message;
            const txtmsg2 = this.translateService.instant(txtmsg);
            this.openSnackBar(txtmsg2, '');
            this.getTaskDetails();
          }
        }
      });
    } else {
      const txtmsg = `You cannot make offer for this task`;
      const txtmsg11 = this.translateService.instant(txtmsg);
      this.openSnackBar(txtmsg11, '');
    }
  }
  withDrawOffer() {
    let message = "You want to withdraw from this Job?";
    let data = {
      isTaskWithdraw: true,
      message: message,
    };
    let obj = {
      postID: this.rawData.postID,
      offeredUserID: this.user.userID,
    };

    let dailogRef = this.dialog.open(WithdrawComponent, {
      panelClass: "col-md-3",
      hasBackdrop: true,
      disableClose: true,
      data: data,
    });

    dailogRef.afterClosed().subscribe((res) => {
      if (res == true) {
        let token = localStorage.getItem("token");
        this.jobService.withDrawOffer(obj, token).subscribe(
          (posRes) => {
            if (posRes.response == 3) {
              const txtmsg = posRes.message;
              const txtmsg1 = this.translateService.instant(txtmsg);
              this.openSnackBar(txtmsg1, '');;
              this.getTaskDetails();
            } else {
              const txtmsg = posRes.message;
              const txtmsg3 = this.translateService.instant(txtmsg);
              this.openSnackBar(txtmsg3, '');;
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.warn("CSE", err.message);
            } else {
              console.warn("SSE", err.message);
            }
          }
        );
      } else {
        console.log(obj);
      }
    });
  }
  showAttachmentPop(image) {
    let dialogRef = this.dialog.open(AttachmentSwiperComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: false,
      data: image,
      height: "50vh",
    });
  }
  changeCategory() {
    let payLoad = { ...this.rawData };
    payLoad.type = "Edit";
    let dialogRef = this.dialog.open(PostAJobComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: true,
      data: payLoad,
    });
    this.showOptions = !this.showOptions;
    dialogRef.afterClosed().subscribe((res) => {
      if (res != undefined) {
        if (res.response == 3) {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
          this.getTaskDetails();         
          this.jobService.isJobPosted.next(true);
        } else {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
        }
      }
    });
  }
  updatePost(status) {
    if (status == "Cancel Task") {
      let dialogRef = this.dialog.open(CancelComponent, {
        panelClass: "col-md-4",
        hasBackdrop: true,
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res.isReason == true) {
          this.delete(res.reason);
        }
      });
    }
    if (status == "Edit") {
      this.changeCategory();
    }
    if (status == "Copy") {
      this.copyTask();
    }
  }
  delete(reason) {
    let obj = {
      postID: this.id,
      reason: reason.trim(),
    };
    let token = localStorage.getItem("token");
    this.jobService.cancelTask(obj, token).subscribe(
      (posRes) => {
        if (posRes.response == 3) {
          this.getTaskDetails();
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
        } else {
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
        }
      },
      (err: HttpErrorResponse) => {
        const txtmsg = err.message.trim();
        const txtmsg2 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg2, '');
        if (err.error instanceof Error) {
          console.log(err.message);
        } else {
          console.log(err.message);
        }
      }
    );
  }
  copyTask() {
    let payLoad = { ...this.rawData };
    payLoad.type = "Copy";
    let dialogRef = this.dialog.open(PostAJobComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: true,
      data: payLoad,
    });
    this.showOptions = !this.showOptions;
    dialogRef.afterClosed().subscribe((res) => {
      if (res != undefined) {
        if (res.response == 3) {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
          this.getTaskDetails();
          this.jobService.isJobPosted.next(true);
        } else {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
        }
      }
    });
  }
  verifyChecked(event, id) {
    if (this.selectedOffersLength <= this.rawData.numberOfWorkers) {
      let index = -1;
      index = this.offers.findIndex((item) => {
        return item.offeredUserID == id;
      });
      if (index != -1) {
        this.isMakeOffersCounteReached = false;
        if (event.checked) {
          this.selectedOffersLength += 1;
        } else {
          this.selectedOffersLength -= 1;
        }
        this.offers[index].isSelected = event.checked;
      }
      if (this.selectedOffersLength === this.rawData.numberOfWorkers) {
        this.isMakeOffersCounteReached = true;
      } else {
        this.isMakeOffersCounteReached = false;
      }
    } else {
      this.isMakeOffersCounteReached = true;
    }
  }

  extractTokenFromURL(url) {
    const urlSearchParams = new URLSearchParams(url);
    const token = urlSearchParams.get("token");
    return token;
  }
  reviewOffers() {
    if (this.selectedOffersLength >= 1) {
      let selectedOffers = this.offers.filter((val) => {
        return val.isSelected;
      });
      if (selectedOffers.length >= 1) {
        let dailogRef = this.dialog.open(PaymentDialogComponent, {
          panelClass: "col-md-4",
          hasBackdrop: true,
          disableClose: true,
          data: { taskTitle: this.rawData.postTitle, offers: selectedOffers },
        });
        dailogRef.afterClosed().subscribe((res) => {
          if (res !== false) {
            this.amount = 0;
            let bookedTaskers = [];
            res.offers.forEach((val) => {
              let obj: any = {
                offeredUserID: val.offeredUserID,
                offeredUserName: val.authorName,
                budget: val.budget,
                offeredUserProfilePic: val.authorProfilePic,
                isCustomerCompletedTask: false,
                isTaskerCompletedTask: false,
                paymentStatusToProviderByAdmin: false,
                isWithDraw: false,
                ratingsToProvider: false,
                ratingsToPoster: false,
                isWithDrawCustomer: false,
              };
              if (val && val.phoneNumber) {
                obj.phoneNumber = val.phoneNumber;
              }
              this.amount += val.budget;
              bookedTaskers.push(obj);
            });
            if (res.isCouponApplied) {
              this.amount -= parseInt(res.couponObj.couponAmount);
              this.couponAmount = "-" + res.couponObj.couponAmount;
              localStorage.setItem("couponAmount", this.couponAmount);
            }
            localStorage.setItem("coupon", JSON.stringify(res.couponObj));
            localStorage.setItem(
              "selectedUsers",
              JSON.stringify(bookedTaskers)
            );
            this.hireTaskers(bookedTaskers);
          }
        });
      } else {
        const txtmsg2 = this.translateService.instant("Select providers to proceed");
        this.openSnackBar(txtmsg2, '');
      }
    } else {
      const txtmsg = this.translateService.instant("Select providers to proceed");
      this.openSnackBar(txtmsg, '');

    }
  }
  makePaymentPhonepay() {
    let money = Math.round(this.amount);
    let obj = {
      merchantTransactionId: this.bookingID,
      // Amount: 1,
      Amount: Number(money),
      mobileNumber: this.user.userID,
      userID: this.user.userID + "@talentasker.com",
      type: "WEB",
      callbackURL: "https://talentasker.com/#/my-tasks/task/" + this.id
    };
    localStorage.setItem("paymentStatus", JSON.stringify(obj));
    let token = localStorage.getItem("token");
    this.jobService.getPhonePeInit(obj, token).subscribe(
      (posRes: any) => {
        const equalsIndex = posRes.data.instrumentResponse.redirectInfo.url.indexOf('=');
        if (equalsIndex !== -1) {

          const substringAfterEquals = posRes.data.instrumentResponse.redirectInfo.url.substring(equalsIndex + 1);
          const form = `<form name="frmPayment" method="GET" action="https://mercury-t2.phonepe.com/transact/pg">
          <input type="hidden" name="token" id="tokenField" value=${substringAfterEquals}>
          </form>`;

          const paymentElement = document.querySelector(".payment") as HTMLFormElement | null;
          if (paymentElement) {
            paymentElement.innerHTML = form;
            const frmPayment = document.querySelector("form[name='frmPayment']") as HTMLFormElement | null;
            if (frmPayment) {
              frmPayment.submit();
            } else {
              console.error("Form with name 'frmPayment' not found.");
            }
          } else {
            console.error("Element with class 'payment' not found.");
          }
        } else {
          this.openSnackBar("Technical issue will try some time", "")
        }
      })
  }

  paymentStatus() {
    let paymentparams = JSON.parse(localStorage.getItem("paymentStatus"));
    let obj = {
      merchantId: "TALENTONLINE",
      merchantTransactionId: paymentparams.merchantTransactionId
    }
    let token = localStorage.getItem("token");
    this.jobService.getPhonePePaymentStatus(obj, token).subscribe(
      (posRes: any) => {
        if (posRes.code == "PAYMENT_SUCCESS") {
          let creatHash =
            "H71BRDU8" +
            "CLS" +
            paymentparams.merchantTransactionId +
            paymentparams.Amount +
            "INR";
          let hash = sha256(creatHash);
          let obj = {
            TransactionType: "TransactionType",
            PymtMethod: "Card",
            ServiceID: "",
            PaymentID: paymentparams.merchantTransactionId,
            Amount: paymentparams.Amount,
            CurrencyCode: "₹",
            HashValue: hash,
          };
          localStorage.removeItem("paymentStatus");
          this.completeHiring(obj);
        } else {
          this.deleteBooking();
          localStorage.removeItem("paymentStatus");
          localStorage.removeItem("selectedUsers");
          localStorage.removeItem("coupon");
        }
      })
  }

  completeHiring(paylodobj) {
    this.loginService.showLoader.next(true);
    let bookingID = localStorage.getItem("bookingID");
    let payLoad = { ...this.paymentObj.params };
    let obj = {
      bookingID: paylodobj.PaymentID,
      paymentData: paylodobj,
    };
    let token = localStorage.getItem("token");
    this.jobService.fullHire(obj, token).subscribe(
      (posRes) => {
        this.loginService.showLoader.next(false);
        if (posRes.response == 3) {
          let obj = {
            isSuccess: true,
          };
          let dialog = this.dialog.open(PaymentStatusComponent, {
            panelClass: "col-md-4",
            hasBackdrop: true,
            disableClose: true,
            data: obj,
          });
          this.getTaskDetails();
        } else {
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
        }
      },
      (err: HttpErrorResponse) => {
        this.loginService.showLoader.next(true);
        const txtmsg = err.message.trim();
        const txtmsg2 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg2, '');
        if (err.error instanceof Error) {
          console.warn("Client Error", err.error);
        } else {
          console.warn("Server Error", err.error);
        }
      }
    );
  }
  deleteBooking() {
    let obj = {
      isSuccess: false,
    };
    let bookingID = localStorage.getItem("bookingID");
    let delObj = {
      bookingID: bookingID,
    };
    let token = localStorage.getItem("token");

    this.jobService.deleteBooking(delObj, token).subscribe(
      (posRes) => {
        localStorage.removeItem("bookingID");
        if (posRes.response == 3) {
          const txtmsg = this.translateService.instant("Your booking deleted..");
          this.openSnackBar(txtmsg, '');
          let dialog = this.dialog.open(PaymentStatusComponent, {
            panelClass: "col-md-4",
            hasBackdrop: true,
            disableClose: true,
            data: obj,
          });
        } else {
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
        }
      },
      (err: HttpErrorResponse) => {
        localStorage.removeItem("bookingID");
        const txtmsg = err.message.trim();
        const txtmsg12 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg12, '');
        if (err.error instanceof Error) {
          console.warn("Client Error", err.error);
        } else {
          console.warn("Server Error", err.error);
        }
      }
    );
  }
  hireTaskers(details) {
    let amount = localStorage.getItem("couponAmount");
    if (amount != null) {
      this.couponAmount = amount;
    }
    let coupon = JSON.parse(localStorage.getItem("coupon"));
    this.bookingID = "STR" + new Date().getTime();
    this.PaymentID = "Pid" + new Date().getTime();
    let hireTaskObj = {
      describeTaskInDetails: this.sampleData.describeTaskInDetails,
      taskDate: this.sampleData.taskDate,
      attachments: this.sampleData.attachments,
      taskTotalBudget: this.amount,
      paymentID: this.PaymentID,
      mustHaves: this.sampleData.mustHaves,
      convenientTimings: this.sampleData.convenientTimings,
      userID: this.user.userID,
      bookingID: this.bookingID,
      postID: this.sampleData.postID,
      customerProfilePic: this.sampleData.userInfo.profilePic,
      location: this.sampleData.location,
      loc: this.sampleData.loc,
      serviceCategory: this.sampleData.category.categoryName,
      taskTitle: this.sampleData.postTitle,
      customerName: this.sampleData.userInfo.firstName,
      paymentStatus: "Pending",
      bookedTaskers: details,
      couponCode: coupon.couponCode,
      couponAmount: coupon.couponAmount,
      couponDiscount: this.couponAmount,
      phoneNumber: this.rawData.userInfo.phoneNumber,
    };
    let token = localStorage.getItem("token");
    this.loginService.showLoader.next(true);
    const txtmsg = this.translateService.instant("This payment is under process");
    this.openSnackBar(txtmsg, '');
    this.jobService.partialHire(hireTaskObj, token).subscribe(
      (posRes) => {
        this.loginService.showLoader.next(true);
        if (posRes.response == 3) {
          localStorage.removeItem("selectedUsers");
          localStorage.removeItem("coupon");
          localStorage.setItem("bookingID", this.bookingID);
          this.makePaymentPhonepay();
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
        } else {
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
        }
      },
      (err: HttpErrorResponse) => {
        this.loginService.showLoader.next(true);
        const txtmsg1 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg1, '');
        if (err.error instanceof Error) {
          console.warn("CSE", err.error);
        } else {
          console.warn("SSE", err.message);
        }
      }
    );
  }
  shareOnFaceBook() {
    this.faceBookUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
      this.shareUrl
    )}?t=${encodeURIComponent(this.shareTaskTitle)}`;
    window.open(this.faceBookUrl, "_blank");
  }
  shareOnTwiter() {
    this.twitterUrl = `https://twitter.com/share?url=${encodeURIComponent(
      this.shareUrl
    )}&amp;text=${encodeURIComponent(
      this.shareTaskTitle
    )}&amp;via=fabienb&amp;hashtags=koandesign`;
    window.open(this.twitterUrl, "_blank");
  }
  shareOnLinkedIn() {
    this.linkedInUrl = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
      this.shareUrl
    )}&amp;title=${encodeURIComponent(this.shareTaskTitle)}`;
    window.open(this.linkedInUrl, "_blank");
  }
  openOptions() {
    this.showOptions = !this.showOptions;
  }
  setSpace() {
    this.commentForm
      .get("author_comment")
      .setValue(this.commentForm.value.author_comment.trim());
  }
  sendComment() {
    this.isWordThere = false;
    let strArray = this.commentForm.value.author_comment.split(" ");
    strArray.forEach((element, index) => {
      let matchPattern = element.match(/\d+/g);
      if (matchPattern != null) {
        var withNoDigits = "";
        withNoDigits = element.replace(/[0-9]/g, "");

        var numb = element.match(/\d/g);
        numb = numb.join("");
        let word = withNoDigits.toLocaleLowerCase();
        if (
          word == "rm" ||
          word == "am" ||
          word == "pm" ||
          word == "year" ||
          word == "years" ||
          word == "hour" ||
          word == "hours"
        ) {
          this.isWordThere = false;
        } else {
          let nextWord = strArray[index + 1];
          let str = ["hours", "hour", "am", "pm", "year", "years"];
          if (!str.includes(nextWord)) {
            this.isWordThere = true;
            return;
          }
        }
        if (numb.length > 5) {
          this.isWordThere = true;
          return;
        }
      }
    });
    strArray.forEach((key) => {
      this.restrictedKeys.forEach((wordKey) => {
        if (key == wordKey) {
          this.isWordThere = true;
          return;
        }
      });
    });
    if (this.isWordThere) {
      return;
    }
    this.websiteKeys.forEach((wordKey) => {
      if (this.commentForm.value.author_comment.indexOf(wordKey) > -1) {
        this.isWordThere = true;
        return;
      }
    });

    if (this.isWordThere) {
      return;
    }
    this.commentForm.patchValue({
      postID: this.rawData.postID,
      author_url: this.user.profilePic,
      author: this.user.firstName,
      author_email: this.user.userID,
      timeStamp: "" + new Date().getTime(),
      gmt_timeStamp: "" + new Date().getTime(),
    });
    let token = localStorage.getItem("token");
    this.jobService.addComments(this.commentForm.value, token).subscribe(
      (posRes) => {
        if (posRes.response == 3) {
          this.commentForm.patchValue({
            author_comment: "",
          });
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
          this.getTaskDetails();
        }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("CSE", err.message);
        } else {
          console.log("SSE", err.message);
        }
      }
    );
  }
  showUserProfile(id) {
    this.router.navigate(["/profile", btoa(id)], {
      queryParams: { isEncpt: "y" },
    });
  }
  replyMsg(msg) {
    if (
      this.rawData.post_Status === "Expired" ||
      this.rawData.post_Status === "Cancel" ||
      this.rawData.post_Status === "Completed"
    ) {
      const txtmsg = `Sorry this task has been ${this.rawData.post_Status}`;
      const txtmsg4 = this.translateService.instant(txtmsg);
      this.openSnackBar(txtmsg4, '');
      return;
    }
    let obj = {
      isPoster: false,
      postID: this.rawData.postID,
      userID: msg.offeredUserID,
    };
    if (!this.amIAppliedThisTask) {
      if (msg.posterCount != 0) {
        obj.isPoster = true;
        this.callMsgCountApi(obj, msg);
      } else {
        this.openRply(msg);
      }
    } else {
      if (msg.providerCount != 0) {
        obj.isPoster = true;
        this.callMsgCountApi(obj, msg);
      } else {
        this.openRply(msg);
      }
    }
  }
  callMsgCountApi(obj, msg) {
    let token = localStorage.getItem("token");
    this.jobService.messageReadUpdate(obj, token).subscribe(
      (posRes) => {
        this.openRply(msg);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          const txtmsg = err.message.trim();
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
          console.warn("Server Failure ::", err.error);
        } else {
          console.warn("Server Failure ::", err.error);
        }
      }
    );
  }
  openRply(msg) {
    if (this.loggedIn) {
      let payLoad = { ...msg };
      payLoad.userID = this.user.userID;
      payLoad.postID = this.rawData.postID;
      let dialogRef = this.dialog.open(ReplyDialogComponent, {
        panelClass: "col-md-4",
        hasBackdrop: true,
        disableClose: true,
        data: payLoad,
      });
      this.showOptions = false;
      dialogRef.afterClosed().subscribe((res) => {
        if (res != undefined) {
          if (res.response == 3) {
            const txtmsg = res.message;
            const txtmsg2 = this.translateService.instant(txtmsg);
            this.openSnackBar(txtmsg2, '');
          } else {
            const txtmsg = res.message;
            const txtmsg2 = this.translateService.instant(txtmsg);
            this.openSnackBar(txtmsg2, '');
          }
        }
        this.getTaskDetails();
      });
    } else {
      this.loginService.callLogin.next(true);
    }
  }
}
